function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useReducer, useRef } from 'react';
import styled from 'styled-components';
import { ChevronRight, Happy, Sad } from '@churchofjesuschrist/eden-icons';
import { accentColorPrimary, backgroundColorLevel3, fontSize14, spacing16, spacing4, spacing8 } from '@churchofjesuschrist/eden-style-constants';
import { Icon } from '@churchofjesuschrist/eden-buttons';
import { Input, InputGroup } from '@churchofjesuschrist/eden-form-parts';
import NoticeMessage from "./NoticeMessage.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var NOOP = function NOOP() {};
var TightNoticeMessage = styled(NoticeMessage).withConfig({
  componentId: "sc-10ib3fj-0"
})(["margin-bottom:0;"]);
var FeebackContainer = styled.div.withConfig({
  componentId: "sc-10ib3fj-1"
})(["width:100%;display:flex;flex-direction:column;"]);

// Reaction
var ReactionsContainer = styled.div.withConfig({
  componentId: "sc-10ib3fj-2"
})(["align-self:center;margin-bottom:", ";"], spacing16);
var ReactionButton = styled(Icon).withConfig({
  componentId: "sc-10ib3fj-3"
})(["margin-top:", ";margin-bottom:", ";"], spacing4, spacing4);

// Message
var ResponseInputGroup = styled(InputGroup).withConfig({
  componentId: "sc-10ib3fj-4"
})(["align-self:center;width:100%;margin-bottom:", ";background-color:", ";"], spacing16, backgroundColorLevel3);
var ResponseInput = styled(Input).withConfig({
  componentId: "sc-10ib3fj-5"
})(["background-color:", ";"], backgroundColorLevel3);
var ResponseBackButton = styled(ReactionButton).withConfig({
  componentId: "sc-10ib3fj-6"
})(["color:", ";&:hover{color:", ";}"], accentColorPrimary, accentColorPrimary);

// Submitted
var SubmittedContainer = styled.div.withConfig({
  componentId: "sc-10ib3fj-7"
})(["align-self:center;display:flex;align-items:center;margin-bottom:", ";"], spacing16);
var SubmittedMessage = styled.div.withConfig({
  componentId: "sc-10ib3fj-8"
})(["font-size:", ";"], fontSize14);
var SubmittedIcon = styled.div.withConfig({
  componentId: "sc-10ib3fj-9"
})(["margin:", " ", ";color:", ";"], spacing8, spacing4, accentColorPrimary);

/**
 * @typedef {object} UserFeedback
 * @property {boolean} positive Whether the user's feedback is positive.
 * @property {string} [message] A feedback message supplied by a user.
 */

/**
 * @typedef {object} Props
 * @property {string} [title] Displayed as a NoticeMessage above the feedback input.
 * @property {string} [placeholder] Placeholder text for the feedback message input.
 * @property {string} [submittedMessage] Text displayed after feedback is submitted.
 * @property {(feedback: UserFeedback) => void} [onFeedback] Event handler for submitted feedback.
 *
 * This is called when the positive/negative icons are clicked, then called again if/when a feedback message is submitted.
 */

/**
 * @param {Props} props
 */
var Feedback = function Feedback(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Was this response helpful?' : _ref$title,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? 'Would you like to offer additional details?' : _ref$placeholder,
    _ref$submittedMessage = _ref.submittedMessage,
    submittedMessage = _ref$submittedMessage === void 0 ? 'Thank you for your feedback.' : _ref$submittedMessage,
    _ref$onFeedback = _ref.onFeedback,
    onFeedback = _ref$onFeedback === void 0 ? NOOP : _ref$onFeedback;
  var inputRef = useRef();
  var ref = useRef();
  var _useReducer = useReducer(function (prev, event) {
      switch (event.type) {
        case 'reaction':
          return {
            state: 'message',
            positive: event.positive,
            message: ''
          };
        case 'message':
          return _objectSpread(_objectSpread({}, prev), {}, {
            message: event.message
          });
        case 'submit':
          return _objectSpread(_objectSpread({}, prev), {}, {
            state: 'submitted'
          });
        case 'back':
          return {
            state: 'reaction'
          };
      }
    }, {
      state: 'reaction'
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _useReducer2$ = _useReducer2[0],
    state = _useReducer2$.state,
    positive = _useReducer2$.positive,
    message = _useReducer2$.message,
    dispatch = _useReducer2[1];
  useEffect(function () {
    if (state === 'message' && inputRef.current) {
      inputRef.current.focus();
    }
  }, [state]);
  var handleReaction = function handleReaction(positive) {
    if (state === 'reaction') {
      dispatch({
        type: 'reaction',
        positive: positive
      });
      onFeedback({
        positive: positive
      });
    }
  };
  var handleMessage = function handleMessage(event) {
    if (state === 'message') {
      dispatch({
        type: 'message',
        message: event.target.value
      });
    }
  };
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    if (state === 'message' && message) {
      dispatch({
        type: 'submit'
      });
      onFeedback({
        positive: positive,
        message: message
      });
    }
  };
  var handleBack = function handleBack(event) {
    event.stopPropagation();
    if (!event.key && state === 'message' || event.key === 'Escape') {
      dispatch({
        type: 'back'
      });
    }
  };
  var content = function () {
    if (state === 'submitted') {
      return /*#__PURE__*/_jsxs(SubmittedContainer, {
        children: [/*#__PURE__*/_jsx(SubmittedIcon, {
          as: positive ? Happy : Sad,
          size: "1.5rem"
        }), /*#__PURE__*/_jsx(SubmittedMessage, {
          children: submittedMessage
        })]
      });
    }
    if (state === 'message') {
      return /*#__PURE__*/_jsx("form", {
        onSubmit: handleSubmit,
        children: /*#__PURE__*/_jsxs(ResponseInputGroup, {
          onKeyDown: handleBack,
          children: [/*#__PURE__*/_jsx(ResponseBackButton, {
            "data-testid": "back",
            onClick: handleBack,
            size: "small",
            type: "button",
            children: positive ? /*#__PURE__*/_jsx(Happy, {}) : /*#__PURE__*/_jsx(Sad, {})
          }), /*#__PURE__*/_jsx(ResponseInput, {
            ref: inputRef,
            value: message,
            onChange: handleMessage,
            placeholder: placeholder,
            "data-testid": "input"
          }), /*#__PURE__*/_jsx(Icon, {
            size: "small",
            type: "submit",
            "data-testid": "submit",
            children: /*#__PURE__*/_jsx(ChevronRight, {})
          })]
        })
      });
    }
    return (
      /*#__PURE__*/
      // state === 'reaction'
      _jsxs(ReactionsContainer, {
        children: [/*#__PURE__*/_jsx(ReactionButton, {
          "data-testid": "positive",
          size: "small",
          onClick: function onClick() {
            return handleReaction(true);
          },
          children: /*#__PURE__*/_jsx(Happy, {})
        }), /*#__PURE__*/_jsx(ReactionButton, {
          "data-testid": "negative",
          size: "small",
          onClick: function onClick() {
            return handleReaction(false);
          },
          children: /*#__PURE__*/_jsx(Sad, {})
        })]
      })
    );
  }();
  return /*#__PURE__*/_jsxs(FeebackContainer, {
    "data-feedback": true,
    ref: ref,
    children: [/*#__PURE__*/_jsx(TightNoticeMessage, {
      "data-scroll": false,
      children: title
    }), content]
  });
};
export default Feedback;